import { eventType, noonReportType } from './enums.js';
import * as dateTimeFormatter from 'odfjell-date-time-utils/dateTimeFormatter.js';
import * as dateTimeUtils from 'odfjell-date-time-utils/dateTimeUtils.js';

export const getAolItemsForDates = (evList, portCalls, fromAolDate, toAolDate, isSimpleMode = false) => {
    evList = evList.sort((a, b) => new Date(a.eventDate.actualDateTimeLocal) - new Date(b.eventDate.actualDateTimeLocal));
    const aolItemsPerDate = {};
    const berthCalls = getBerthCalls(portCalls);
    const aolItemsPortCall = getAolItemsForPortCall(evList, berthCalls, isSimpleMode);

    if (aolItemsPortCall.length > 0) {
        let aolDate = fromAolDate;
        while (aolDate <= toAolDate) {
            const aolItems = [];
            const dateKey = dateTimeFormatter.formatDateTime(aolDate, 'yyyy-MM-ddTHH:mm');
            for (const aolItem of aolItemsPortCall) {
                const included = includeAolItem(aolDate, aolItem);
                if (included) {
                    const newAolItem = {
                        startTimeLocalTime: getAolStartDate(aolDate, aolItem.startTimeLocalTime),
                        stopTimeLocalTime: getAolStopDate(aolDate, aolItem.stopTimeLocalTime),
                        noonReportType: aolItem.noonReportType,
                        imosPortCallId: aolItem.imosPortCallId,
                        isValid: aolItem.isValid,
                        errorEvents: aolItem.errorEvents,
                    };
                    aolItems.push(newAolItem);
                }
            }
            aolItemsPerDate[dateKey] = aolItems;
            aolDate = dateTimeUtils.addDateDays(aolDate, 1);
        }
    }

    const sortedAolItemsPerDate = Object.keys(aolItemsPerDate)
        .sort() // Sort the keys
        .reduce((acc, key) => {
            acc[key] = aolItemsPerDate[key]; // Build a new object
            return acc;
        }, {});
    return sortedAolItemsPerDate;
};

export const getAolItemsForDate = (evList, portCalls, aolDate, isSimpleMode = false) => {
    evList = evList.sort((a, b) => new Date(a.eventDate.actualDateTimeLocal) - new Date(b.eventDate.actualDateTimeLocal));
    const aolItems = [];
    const berthCalls = getBerthCalls(portCalls);

    var aolItemsPortCall = getAolItemsForPortCall(evList, berthCalls, isSimpleMode);
    if (aolItemsPortCall.length > 0) {
        for (const aolItem of aolItemsPortCall) {
            if (includeAolItem(aolDate, aolItem)) {
                aolItem.startTimeLocalTime = getAolStartDate(aolDate, aolItem.startTimeLocalTime);
                aolItem.stopTimeLocalTime = getAolStopDate(aolDate, aolItem.stopTimeLocalTime);
                aolItems.push(aolItem);
            }
        }
    }
    return aolItems;
};

export const getAolItemsForPortCall = (evList, berthCalls, isSimpleMode = false) => {
    const aolItems = [];
    // Filter evList
    // evList = isSimpleMode ? filterSimpleAolTypeEvents(evList) : getEventsFilteredOnEospSops(evList);

    // Add valid sea item
    const aolItemSeaFirst = {
        startTimeLocalTime: new Date(-8640000000000000), // Minimum value of date
        stopTimeLocalTime:
            evList.length > 0 && evList[0].eventDate.actualDateTimeLocal
                ? new Date(evList[0].eventDate.actualDateTimeLocal)
                : new Date(8640000000000000), // Maximum value of date
        noonReportType: noonReportType.sea,
        imosPortCallId: evList.length > 0 ? evList[0].portCallId : null,
        isValid: true,
        errorEvents: [],
    };

    aolItems.push(aolItemSeaFirst);

    if (evList.length > 0) {
        // If first <> EOSP add invalid port item and return
        if (evList[0].eventTypeId != eventType.eosp) {
            const aolItem = {
                startTimeLocalTime: new Date(-8640000000000000), // Minimum value of date
                stopTimeLocalTime:
                    evList.length > 0 && evList[0].eventDate.actualDateTimeLocal
                        ? new Date(evList[0].eventDate.actualDateTimeLocal)
                        : new Date(8640000000000000), // Maximum value of date
                noonReportType: getAolType(
                    evList[0],
                    hasFutureBerthCallsWithNoEvents(berthCalls, evList, evList[0].portClusterCallId),
                    evList.length > 2 ? evList[1] : null,
                    isSimpleMode
                ),
                imosPortCallId: evList[0].portCallId,
                isValid: false,
                errorEvents: createErrorEventList(evList[0]),
            };

            aolItems.push(aolItem);
        } else {
            const aolItemFirst = {
                startTimeLocalTime: new Date(evList[0].eventDate.actualDateTimeLocal),
                stopTimeLocalTime: new Date(8640000000000000), // Maximum value of date
                noonReportType: getAolType(
                    evList[0],
                    hasFutureBerthCallsWithNoEvents(berthCalls, evList, evList[0].portClusterCallId),
                    evList.length > 2 ? evList[1] : null,
                    isSimpleMode
                ),
                imosPortCallId: evList[0].portCallId,
                isValid: true,
                errorEvents: [],
            };

            aolItems.push(aolItemFirst);
            let keepGoing = evList.length > 1;
            let ind = 1;
            while (keepGoing) {
                // If next event is valid: add valid aol item
                const _isEventValid = isSimpleMode ? isSimpleEventValid(evList[ind - 1], evList[ind]) : isEventValid(evList[ind - 1], evList[ind]);

                if (_isEventValid) {
                    const aolType = getAolType(
                        evList[ind],
                        hasFutureBerthCallsWithNoEvents(berthCalls, evList, evList[ind].portClusterCallId),
                        evList.length > ind + 1 ? evList[ind + 1] : null,
                        isSimpleMode
                    );
                    const previousAolItem = aolItems[aolItems.length - 1];
                    const startTime = new Date(evList[ind].eventDate.actualDateTimeLocal);
                    if (previousAolItem.noonReportType != aolType) {
                        const aolItem = {
                            startTimeLocalTime: startTime,
                            stopTimeLocalTime: new Date(8640000000000000), // Maximum value of date
                            noonReportType: aolType,
                            imosPortCallId: evList[ind].portCallId,
                            isValid: true,
                            errorEvents: [],
                        };
                        aolItems.push(aolItem);
                        previousAolItem.stopTimeLocalTime = startTime;
                    }
                    ind++;
                    keepGoing = ind < evList.length;
                } else {
                    const startTime = new Date(evList[ind].eventDate.actualDateTimeLocal);
                    // If next event is not valid: add invalid aol item and return
                    const previousAolItem = aolItems[aolItems.length - 1];
                    const aolItem = {
                        startTimeLocalTime: startTime,
                        stopTimeLocalTime: new Date(8640000000000000), // Maximum value of date
                        noonReportType: getAolType(
                            evList[ind],
                            hasFutureBerthCallsWithNoEvents(berthCalls, evList, evList[ind].portClusterCallId),
                            evList.length > ind + 1 ? evList[ind + 1] : null,
                            isSimpleMode
                        ),
                        imosPortCallId: evList[ind].portCallId,
                        isValid: false,
                        errorEvents: createErrorEventList(evList[ind - 1], evList[ind]),
                    };
                    aolItems.push(aolItem);
                    previousAolItem.stopTimeLocalTime = startTime;
                    keepGoing = false;
                }
            }
        }
    }
    return aolItems;
};
const getBerthCalls = (portCalls) => {
    return portCalls
        .flatMap((x) => x.portCallItems.map((y) => [x.portClusterCallId ?? x.portCallId, y.berthCall]))
        .filter((x) => x[0] !== null)
        .map((x) => [x[0], x[1]]);
};

const getAolType = (ev, hasEmptyBerthCalls, nextEvent, isSimpleMode = false) => {
    if (isSimpleMode) {
        return getSimpleAolType(ev, nextEvent);
    } else {
        switch (ev.eventTypeId) {
            case eventType.eosp:
                return isArrival(ev.eventTypeId, hasEmptyBerthCalls, nextEvent) ? noonReportType.arrival : noonReportType.port;
            case eventType.sosp:
                return noonReportType.sea;
            case eventType.allFast:
                return noonReportType.port;
            case eventType.allClear:
                return isArrival(ev.eventTypeId, hasEmptyBerthCalls, nextEvent) ? noonReportType.port : noonReportType.departure;
            case eventType.wellAnchoredCargoOps:
                return noonReportType.port;
            case eventType.anchorAweighCargoOps:
                return isArrival(ev.eventTypeId, hasEmptyBerthCalls, nextEvent) ? noonReportType.port : noonReportType.departure;
            case eventType.wellAnchoredNoCargo:
                return noonReportType.port;
            case eventType.anchorAweighNoCargo:
                return isArrival(ev.eventTypeId, hasEmptyBerthCalls, nextEvent) ? noonReportType.port : noonReportType.departure;
            case eventType.dryDockingCommenced:
                return noonReportType.port;
            case eventType.dryDockingCompleted:
                return isArrival(ev.eventTypeId, hasEmptyBerthCalls, nextEvent) ? noonReportType.port : noonReportType.departure;
            case eventType.dryDockingBerthCommenced:
                return noonReportType.port;
            case eventType.dryDockingBerthCompleted:
                return isArrival(ev.eventTypeId, hasEmptyBerthCalls, nextEvent) ? noonReportType.port : noonReportType.departure;
            case eventType.bunkerBargeAlongsideAtBerth:
                return noonReportType.port;
            case eventType.bunkerBargeCastedOffAtBerth:
                return isArrival(ev.eventTypeId, hasEmptyBerthCalls, nextEvent) ? noonReportType.port : noonReportType.departure;
        }
        return noonReportType.sea;
    }
};

const isArrival = (eventTypeId, hasEmptyBerthCalls, nextEvent) => {
    if (nextEvent == null) return hasEmptyBerthCalls;
    switch (eventTypeId) {
        case eventType.eosp:
            return hasEmptyBerthCalls || isArrivalStartEvent(nextEvent.eventTypeId);
        case eventType.sosp:
            return hasEmptyBerthCalls;
        case eventType.allFast:
            return hasEmptyBerthCalls;
        case eventType.allClear:
            return hasEmptyBerthCalls || isArrivalStartEvent(nextEvent.eventTypeId);
        case eventType.wellAnchoredCargoOps:
            return hasEmptyBerthCalls;
        case eventType.anchorAweighCargoOps:
            return hasEmptyBerthCalls || isArrivalStartEvent(nextEvent.eventTypeId);
        case eventType.wellAnchoredNoCargo:
            return hasEmptyBerthCalls;
        case eventType.anchorAweighNoCargo:
            return hasEmptyBerthCalls || isArrivalStartEvent(nextEvent.eventTypeId);
        case eventType.dryDockingCommenced:
            return hasEmptyBerthCalls;
        case eventType.dryDockingCompleted:
            return hasEmptyBerthCalls || isArrivalStartEvent(nextEvent.eventTypeId);
        case eventType.dryDockingBerthCommenced:
            return hasEmptyBerthCalls;
        case eventType.dryDockingBerthCompleted:
            return hasEmptyBerthCalls || isArrivalStartEvent(nextEvent.eventTypeId);
        case eventType.bunkerBargeAlongsideAtBerth:
            return hasEmptyBerthCalls;
        case eventType.bunkerBargeCastedOffAtBerth:
            return hasEmptyBerthCalls || isArrivalStartEvent(nextEvent.eventTypeId);
    }
    return false;
};

const getSimpleAolType = (ev, nextEvent) => {
    switch (ev.eventTypeId) {
        case eventType.eosp:
            return isSimpleArrival(ev.eventTypeId, nextEvent) ? noonReportType.arrival : noonReportType.port;
        case eventType.sosp:
            return noonReportType.sea;
        case eventType.simpleBerthArrival:
            return noonReportType.port;
        case eventType.simpleBerthDeparture:
            return isSimpleArrival(ev.eventTypeId, nextEvent) ? noonReportType.port : noonReportType.departure;
        case eventType.wellAnchored:
            return noonReportType.port; // At anchor is a port activity
        case eventType.anchorAweigh:
            return isSimpleArrival(ev.eventTypeId, nextEvent) ? noonReportType.port : noonReportType.departure;
    }
    return noonReportType.sea;
};

const isSimpleArrival = (eventTypeId, nextEvent) => {
    if (nextEvent == null) return false;
    switch (eventTypeId) {
        case eventType.eosp:
            return isArrivalSimpleStartEvent(nextEvent.eventTypeId);
        case eventType.sosp:
            return false;
        case eventType.simpleBerthArrival:
            return true;
        case eventType.simpleBerthDeparture:
            return isArrivalSimpleStartEvent(nextEvent.eventTypeId);
        case eventType.wellAnchored:
            return true; // At anchor, waiting for next event
        case eventType.anchorAweigh:
            return isArrivalSimpleStartEvent(nextEvent.eventTypeId);
    }
    return false;
};

const isArrivalSimpleStartEvent = (eventTypeId) => {
    return eventTypeId == eventType.simpleBerthArrival;
};

const isArrivalStartEvent = (eventTypeId) => {
    return (
        eventTypeId === eventType.allFast ||
        eventTypeId === eventType.wellAnchoredCargoOps ||
        eventTypeId === eventType.wellAnchoredNoCargo ||
        eventTypeId === eventType.dryDockingCommenced ||
        eventTypeId === eventType.dryDockingBerthCommenced ||
        eventTypeId === eventType.bunkerBargeAlongsideAtBerth
    );
};

const hasFutureBerthCallsWithNoEvents = (bcList, evList, portClusterCallId) => {
    if (portClusterCallId !== null && bcList.length > 0) {
        const bcListInCluster = bcList.filter((o) => o[0] === portClusterCallId);
        if (bcListInCluster.length > 0) {
            const emptyBerthCalls = bcListInCluster.filter(
                (bc) => !evList.some((ev) => ev.berthCallId !== null && ev.berthCallId === bc[1].berthCallId)
            );
            return emptyBerthCalls.length > 0;
        }
    }
    return false;
};

const createErrorEventList = (...events) => events.map((ev) => createErrorEvent(ev));

const createErrorEvent = (ev) => ({
    eventId: ev.eventId,
    eventDate: ev.eventDate,
    eventTypeId: ev.eventTypeId,
    portCallId: ev.portCallId,
    portClusterCallId: ev.portClusterCallId,
    portClusterId: ev.portClusterId,
    berthId: ev.berthId,
    voyageNumber: ev.voyageNumber,
    portName: '',
    berthName: '',
});

const isSimpleEventValid = (prevEv, ev) => {
    if (prevEv.portClusterCallId !== ev.portClusterCallId && prevEv.eventTypeId !== eventType.sosp) {
        return false;
    }

    switch (prevEv.eventTypeId) {
        case eventType.eosp:
            return (
                ev.eventTypeId === eventType.sosp ||
                ev.eventTypeId === eventType.simpleBerthArrival ||
                ev.eventTypeId === eventType.simpleBerthDeparture ||
                ev.eventTypeId === eventType.wellAnchored // Support anchoring after EOSP in simple mode
            );
        case eventType.sosp:
            return prevEv.portClusterCallId !== ev.portClusterCallId;
        case eventType.simpleBerthArrival:
            return ev.eventTypeId === eventType.simpleBerthDeparture || ev.eventTypeId === eventType.wellAnchored; // Vessel may shift from berth to anchorage
        case eventType.simpleBerthDeparture:
            return ev.eventTypeId === eventType.sosp || ev.eventTypeId === eventType.wellAnchored;
        case eventType.wellAnchored:
            return ev.eventTypeId === eventType.anchorAweigh;
        case eventType.anchorAweigh:
            return (
                ev.eventTypeId === eventType.sosp ||
                ev.eventTypeId === eventType.simpleBerthArrival ||
                ev.eventTypeId === eventType.simpleBerthDeparture ||
                ev.eventTypeId === eventType.wellAnchored // Support multiple anchoring sequences
            );
        default:
            return false;
    }
};

const isEventValid = (prevEv, ev) => {
    if (
        prevEv.portClusterCallId &&
        ev.portClusterCallId &&
        prevEv.portClusterCallId !== ev.portClusterCallId &&
        prevEv.eventTypeId !== eventType.sosp
    ) {
        return false;
    }

    switch (prevEv.eventTypeId) {
        case eventType.eosp:
        case eventType.allClear:
        case eventType.anchorAweighCargoOps:
        case eventType.anchorAweighNoCargo:
        case eventType.dryDockingCompleted:
        case eventType.dryDockingBerthCompleted:
        case eventType.bunkerBargeCastedOffAtBerth:
            return ev.eventTypeId === eventType.sosp || isArrivalStartEvent(ev.eventTypeId);
        case eventType.sosp:
            if (!prevEv.portClusterCallId && !ev.portClusterCallId) return true;
            return prevEv.portClusterCallId !== ev.portClusterCallId;
        case eventType.allFast:
            return ev.eventTypeId === eventType.allClear;
        case eventType.wellAnchoredCargoOps:
            return ev.eventTypeId === eventType.anchorAweighCargoOps;
        case eventType.wellAnchoredNoCargo:
            return ev.eventTypeId === eventType.anchorAweighNoCargo;
        case eventType.dryDockingCommenced:
            return ev.eventTypeId === eventType.dryDockingCompleted;
        case eventType.dryDockingBerthCommenced:
            return ev.eventTypeId === eventType.dryDockingBerthCompleted;
        case eventType.bunkerBargeAlongsideAtBerth:
            return ev.eventTypeId === eventType.bunkerBargeCastedOffAtBerth;
        default:
            return false;
    }
};

const includeAolItem = (aolDate, aolItem) => {
    // Use Luxon .set({ hour: 12 }) to get DST-safe noon boundaries,
    // consistent with getAolStartDate/getAolStopDate clipping functions.
    // Simple hour arithmetic (addDateHours/subtractDateHours) fails on DST
    // transition days where midnight-to-noon spans fewer/more than 12 hours.
    const luxonDate = dateTimeUtils.getLuxonDateTime(aolDate);
    const aolStartTime = luxonDate.set({ hour: 12, minute: 0, second: 0, millisecond: 0 }).minus({ days: 1 }).toJSDate();
    const aolStopTime = luxonDate.set({ hour: 12, minute: 0, second: 0, millisecond: 0 }).toJSDate();
    const startBetween = aolStartTime >= aolItem.startTimeLocalTime && aolStartTime < aolItem.stopTimeLocalTime;
    const stopBetween = aolStopTime > aolItem.startTimeLocalTime && aolStopTime <= aolItem.stopTimeLocalTime;
    const spanning = aolStartTime < aolItem.startTimeLocalTime && aolStopTime > aolItem.stopTimeLocalTime;

    return startBetween || stopBetween || spanning;
};

const getAolStartDate = (aolDate, aolItemDate) => {
    // Use Luxon to set time directly to avoid DST issues
    const modifiedAolDate = dateTimeUtils
        .getLuxonDateTime(aolDate)
        .set({ hour: 12, minute: 0, second: 0, millisecond: 0 })
        .minus({ days: 1 })
        .toJSDate();
    return modifiedAolDate > aolItemDate ? modifiedAolDate : aolItemDate;
};

const getAolStopDate = (aolDate, aolItemDate) => {
    // Use Luxon to set time directly to avoid DST issues when crossing DST boundaries
    const modifiedAolDate = dateTimeUtils.getLuxonDateTime(aolDate).set({ hour: 12, minute: 0, second: 0, millisecond: 0 }).toJSDate();
    return modifiedAolDate < aolItemDate ? modifiedAolDate : aolItemDate;
};
